import { useState, useEffect, useRef, useContext } from 'react';
import {useNavigate} from "react-router-dom";
import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import { AuthContext } from '../Auth/AuthContext';
import axios from 'axios';
import TextField from "@mui/material/TextField";
import { Button, Alert, Snackbar } from "@mui/material";
import IconButton from '@mui/material/IconButton';

const Login = () => {
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const navigate = useNavigate()
    const auth = useContext(AuthContext);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setError(false);
    };
    
  
    const secondary = '#4a7011';
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
  
    const login = async (e) => {
        localStorage.clear();
        e.preventDefault();
        try {
            const response = await axios.post('https://api.sigmasystems.com.br/api/ag-barber/login', {
                email,
                senha,
            },{
                headers:{'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',}});
    
            const data = response.data;
            console.log(response.data)
            
            if (data.token) {
                auth.login(data.token);
                navigate('/Agendamentos'); 
            } else {
                alert('Login falhou!');
            }
        } catch (error) {
            setError(true);
            setErrorText('Usuário ou Senha Inválida!');
        }
    };

    return (
        <div className="container-login">
            <div className="content-login">
                <div className="welcome">
                    <img src="/Images/bot-3d.png" alt="logo-bot-sigma" className="iconBot-login"/>
                    <h1 className='welcome-title'>Bem Vindo!</h1>
                    <h3 className='welcome-subtitle'>Não possui um login? <a href='https://wa.me/+5545991185670' style={{textDecoration:'none'}}><span className='btn-contratar'>Contratar!</span></a></h3>
                </div>
                <div className='formLogin'>
                    <TextField 
                        id="outlined-basic"
                        placeholder='Email'
                        variant="outlined"
                        sx={{width:350, backgroundColor:'#fff',borderRadius:1}}
                        color='success'
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <FormControl sx={{width:350, marginTop:1, backgroundColor:'#fff',borderRadius:1}}
                        color="success" variant="outlined" value={senha} onChange={e => setSenha(e.target.value)}>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                edge="end"
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                            placeholder='Senha'
                        />
                    </FormControl>
                    <Button onClick={login} variant="contained" sx={{backgroundColor:secondary, width:350, height:56, fontFamily:'Montserrat', fontSize:18, '&:hover': {backgroundColor:secondary}, marginTop:2}}>Entrar</Button>
                    <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
                        <Alert
                        onClose={handleClose}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                        >
                        {errorText}
                        </Alert>
                    </Snackbar>
                </div>
            </div>
        </div>
    )
}
export default Login;